// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Summit 2026 Theme Overrides
 *
 * Scoped under body.summit-theme so they only apply when the Summit colour
 * theme is active.  Overrides Cloudscape Design System CSS custom properties
 * to apply the Summit 2026 branded colour palette.
 *
 * Colour palette (from 2026 Summits Standard Build Guide, page 6):
 *   Violet 50   #F6F5FF   – light body background
 *   Violet 600  #250070   – side nav / panels
 *   Violet 950  #110033   – top navigation background
 *   Violet 2735 #8F0072   – primary accent (light mode)
 *   Magenta 300 #FF9E9E   – highlight elements
 *   Purple 400  #D4A8FF   – primary accent (dark mode)
 *   Cyan 300    #00D2E5   – links / interactive
 */

/* ===================================================================
   LIGHT MODE — Summit 2026
   =================================================================== */

body.summit-theme {
  /* ---- Body / layout backgrounds ---- */
  --color-background-layout-main-5ilwcb: #F6F5FF;

  /* Container content & header (white/light for cards and sections) */
  --color-background-container-content-6u8rvp: #FFFFFF;
  --color-background-container-header-gs3mbe: #F6F5FF;

  /* Side navigation / panel backgrounds */
  --color-background-layout-panel-content-xto15e: #250070;
  --color-background-layout-panel-hover-tguulw: #1A004D;
  --color-background-layout-mobile-panel-ed0ava: #250070;

  /* Layout toggle buttons (nav open/close) */
  --color-background-layout-toggle-default-2hgjdu: #250070;
  --color-background-layout-toggle-hover-0cpm7g: #1A004D;
  --color-background-layout-toggle-active-ap91vm: #110033;
  --color-background-layout-toggle-selected-default-izfana: #8F0072;
  --color-background-layout-toggle-selected-hover-7953u1: #6D0058;
  --color-background-layout-toggle-selected-active-zcl8w3: #8F0072;

  /* Dropdown backgrounds */
  --color-background-dropdown-item-default-qmc033: #F6F5FF;
  --color-background-dropdown-item-hover-yunepc: #E8E5FF;
  --color-background-dropdown-item-selected-f3v6te: #D4A8FF;
  --color-background-dropdown-item-filter-match-49b5vt: #E8E5FF;

  /* Input backgrounds */
  --color-background-input-default-ifz5bb: #FFFFFF;

  /* Button – primary */
  --color-background-button-primary-default-vdt0fu: #8F0072;
  --color-background-button-primary-hover-mo85i6: #6D0058;
  --color-background-button-primary-active-5cqoqt: #8F0072;

  /* Button – normal */
  --color-background-button-normal-default-7f99mv: transparent;
  --color-background-button-normal-hover-53op9s: rgba(143, 0, 114, 0.08);
  --color-background-button-normal-active-5imwxd: rgba(143, 0, 114, 0.15);

  /* Button – link */
  --color-background-button-link-hover-lhrs2u: rgba(0, 210, 229, 0.08);
  --color-background-button-link-active-5oi2dp: rgba(0, 210, 229, 0.15);

  /* ---- Text colours ---- */

  /* Top navigation title */
  --color-text-top-navigation-title-en0v40: #FFFFFF;

  /* Body & heading text */
  --color-text-body-default-vvtq8u: #1A0040;
  --color-text-body-secondary-bcbgoi: #3D2066;
  --color-text-heading-default-izpp46: #110033;
  --color-text-heading-secondary-iwtvf6: #3D2066;

  /* Accent / interactive text */
  --color-text-accent-n1kmht: #8F0072;
  --color-text-interactive-default-ugh9wp: #00D2E5;
  --color-text-interactive-hover-6naf7i: #00B8CC;
  --color-text-interactive-active-uoe6zi: #009DAD;
  --color-text-interactive-inverted-default-xlc0d5: #FFFFFF;
  --color-text-interactive-inverted-hover-65rnp7: #F6F5FF;

  /* Link text */
  --color-text-link-default-1dmm7z: #00D2E5;
  --color-text-link-hover-sq1gxg: #00B8CC;
  --color-text-link-button-normal-default-5w3m67: #00D2E5;
  --color-text-link-button-normal-hover-4awpjm: #00B8CC;
  --color-text-link-button-normal-active-js9ryu: #009DAD;

  /* Button text – primary */
  --color-text-button-primary-default-mwl31m: #FFFFFF;
  --color-text-button-primary-hover-pw12ep: #FFFFFF;
  --color-text-button-primary-active-refmba: #FFFFFF;

  /* Button text – normal */
  --color-text-button-normal-default-nzalii: #8F0072;
  --color-text-button-normal-hover-gusgyv: #6D0058;
  --color-text-button-normal-active-vihsxh: #8F0072;

  /* Status text */
  --color-text-status-info-ue8bd2: #00D2E5;

  /* ---- Border colours ---- */

  --color-border-divider-default-nr68jt: rgba(37, 0, 112, 0.2);
  --color-border-divider-active-biq3j4: #8F0072;
  --color-border-divider-panel-bottom-bruvuz: rgba(37, 0, 112, 0.3);
  --color-border-divider-panel-side-an0w07: rgba(37, 0, 112, 0.3);

  --color-border-item-focused-uk47pl: #00D2E5;
  --color-border-control-checked-bdv28l: #8F0072;
  --color-border-control-default-sh3548: #250070;
  --color-border-input-default-317xk5: rgba(37, 0, 112, 0.4);
  --color-border-input-focused-4z0pgn: #00D2E5;

  --color-border-button-normal-default-glqfp1: #8F0072;
  --color-border-button-normal-hover-6a2tdq: #6D0058;
  --color-border-button-normal-active-ru7yhb: #8F0072;

  /* ---- Transition for smooth theme switching (Req 5.1) ---- */
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Direct element overrides for TopNavigation header bar */
body.summit-theme header[class*="top-navigation"],
body.summit-theme nav[class*="top-navigation"],
body.summit-theme [class*="top-navigation"] > [class*="header"] {
  background: #110033 !important;
  color: #FFFFFF !important;
}

/* Side navigation panel text colours (light on dark background) */
body.summit-theme [class*="side-navigation"] {
  color: #F6F5FF;
}

body.summit-theme [class*="side-navigation"] a,
body.summit-theme [class*="side-navigation"] [class*="link"] {
  color: #D4A8FF;
}

body.summit-theme [class*="side-navigation"] a:hover,
body.summit-theme [class*="side-navigation"] [class*="link"]:hover {
  color: #FFFFFF;
}

body.summit-theme [class*="side-navigation"] [class*="header"] {
  color: #FFFFFF;
}

/* ===================================================================
   DARK MODE — Summit 2026
   =================================================================== */

body.summit-theme.awsui-dark-mode {
  /* ---- Body / layout backgrounds ---- */
  --color-background-layout-main-5ilwcb: #0D001F;

  /* Container content & header (slightly lighter than page bg for contrast) */
  --color-background-container-content-6u8rvp: #150029;
  --color-background-container-header-gs3mbe: #1A0033;

  /* Side navigation / panel backgrounds (darker variant) */
  --color-background-layout-panel-content-xto15e: #1A004D;
  --color-background-layout-panel-hover-tguulw: #110033;
  --color-background-layout-mobile-panel-ed0ava: #1A004D;

  /* Layout toggle buttons */
  --color-background-layout-toggle-default-2hgjdu: #1A004D;
  --color-background-layout-toggle-hover-0cpm7g: #250070;
  --color-background-layout-toggle-active-ap91vm: #110033;
  --color-background-layout-toggle-selected-default-izfana: #D4A8FF;
  --color-background-layout-toggle-selected-hover-7953u1: #C48EFF;
  --color-background-layout-toggle-selected-active-zcl8w3: #D4A8FF;

  /* Dropdown backgrounds */
  --color-background-dropdown-item-default-qmc033: #1A004D;
  --color-background-dropdown-item-hover-yunepc: #250070;
  --color-background-dropdown-item-selected-f3v6te: #3D2066;
  --color-background-dropdown-item-filter-match-49b5vt: #250070;

  /* Input backgrounds */
  --color-background-input-default-ifz5bb: #0D001F;

  /* Button – primary (Purple 400 for dark legibility) */
  --color-background-button-primary-default-vdt0fu: #D4A8FF;
  --color-background-button-primary-hover-mo85i6: #C48EFF;
  --color-background-button-primary-active-5cqoqt: #D4A8FF;

  /* Button – normal */
  --color-background-button-normal-default-7f99mv: transparent;
  --color-background-button-normal-hover-53op9s: rgba(212, 168, 255, 0.1);
  --color-background-button-normal-active-5imwxd: rgba(212, 168, 255, 0.18);

  /* Button – link */
  --color-background-button-link-hover-lhrs2u: rgba(0, 210, 229, 0.1);
  --color-background-button-link-active-5oi2dp: rgba(0, 210, 229, 0.18);

  /* ---- Text colours ---- */

  /* Top navigation title */
  --color-text-top-navigation-title-en0v40: #FFFFFF;

  /* Body & heading text (light for dark backgrounds) */
  --color-text-body-default-vvtq8u: #E8E5FF;
  --color-text-body-secondary-bcbgoi: #C4B8E0;
  --color-text-heading-default-izpp46: #FFFFFF;
  --color-text-heading-secondary-iwtvf6: #D4A8FF;

  /* Accent / interactive text (Purple 400 for dark legibility) */
  --color-text-accent-n1kmht: #D4A8FF;
  --color-text-interactive-default-ugh9wp: #00D2E5;
  --color-text-interactive-hover-6naf7i: #33DDEC;
  --color-text-interactive-active-uoe6zi: #00D2E5;
  --color-text-interactive-inverted-default-xlc0d5: #110033;
  --color-text-interactive-inverted-hover-65rnp7: #0D001F;

  /* Link text (Cyan 300 — same in dark for consistency) */
  --color-text-link-default-1dmm7z: #00D2E5;
  --color-text-link-hover-sq1gxg: #33DDEC;
  --color-text-link-button-normal-default-5w3m67: #00D2E5;
  --color-text-link-button-normal-hover-4awpjm: #33DDEC;
  --color-text-link-button-normal-active-js9ryu: #00D2E5;

  /* Button text – primary (dark text on light Purple 400 bg) */
  --color-text-button-primary-default-mwl31m: #110033;
  --color-text-button-primary-hover-pw12ep: #110033;
  --color-text-button-primary-active-refmba: #110033;

  /* Button text – normal */
  --color-text-button-normal-default-nzalii: #D4A8FF;
  --color-text-button-normal-hover-gusgyv: #C48EFF;
  --color-text-button-normal-active-vihsxh: #D4A8FF;

  /* Status text */
  --color-text-status-info-ue8bd2: #00D2E5;

  /* ---- Border colours ---- */

  --color-border-divider-default-nr68jt: rgba(212, 168, 255, 0.2);
  --color-border-divider-active-biq3j4: #D4A8FF;
  --color-border-divider-panel-bottom-bruvuz: rgba(212, 168, 255, 0.25);
  --color-border-divider-panel-side-an0w07: rgba(212, 168, 255, 0.25);

  --color-border-item-focused-uk47pl: #00D2E5;
  --color-border-control-checked-bdv28l: #D4A8FF;
  --color-border-control-default-sh3548: #D4A8FF;
  --color-border-input-default-317xk5: rgba(212, 168, 255, 0.35);
  --color-border-input-focused-4z0pgn: #00D2E5;

  --color-border-button-normal-default-glqfp1: #D4A8FF;
  --color-border-button-normal-hover-6a2tdq: #C48EFF;
  --color-border-button-normal-active-ru7yhb: #D4A8FF;

  /* ---- Transition for smooth theme switching (Req 5.1) ---- */
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Direct element overrides for TopNavigation in dark mode */
body.summit-theme.awsui-dark-mode header[class*="top-navigation"],
body.summit-theme.awsui-dark-mode nav[class*="top-navigation"],
body.summit-theme.awsui-dark-mode [class*="top-navigation"] > [class*="header"] {
  background: #110033 !important;
  color: #FFFFFF !important;
}

/* Side navigation panel text colours in dark mode */
body.summit-theme.awsui-dark-mode [class*="side-navigation"] {
  color: #E8E5FF;
}

body.summit-theme.awsui-dark-mode [class*="side-navigation"] a,
body.summit-theme.awsui-dark-mode [class*="side-navigation"] [class*="link"] {
  color: #D4A8FF;
}

body.summit-theme.awsui-dark-mode [class*="side-navigation"] a:hover,
body.summit-theme.awsui-dark-mode [class*="side-navigation"] [class*="link"]:hover {
  color: #FFFFFF;
}

body.summit-theme.awsui-dark-mode [class*="side-navigation"] [class*="header"] {
  color: #FFFFFF;
}


/* ===================================================================
   DARK MODE — Content readability fixes
   Overrides hardcoded inline colours in ReviewPage, InsightsSection,
   and CitationPanel so text is legible on dark backgrounds.
   =================================================================== */

/* --- ReviewPage markdown renderer (inline styles use high specificity) --- */

body.summit-theme.awsui-dark-mode h1[style],
body.summit-theme.awsui-dark-mode h2[style],
body.summit-theme.awsui-dark-mode h3[style] {
  color: #E8E5FF !important;
}

body.summit-theme.awsui-dark-mode p[style] {
  color: #D4CCF0 !important;
}

body.summit-theme.awsui-dark-mode li[style] {
  color: #D4CCF0 !important;
}

body.summit-theme.awsui-dark-mode strong[style] {
  color: #F6F5FF !important;
}

body.summit-theme.awsui-dark-mode em[style] {
  color: #C4B8E0 !important;
}

body.summit-theme.awsui-dark-mode code[style] {
  background: #1A004D !important;
  color: #D4A8FF !important;
}

body.summit-theme.awsui-dark-mode pre[style] {
  background: #1A004D !important;
  border-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode blockquote[style] {
  background: #1A004D !important;
  border-left-color: #00D2E5 !important;
  color: #C4B8E0 !important;
}

body.summit-theme.awsui-dark-mode hr[style] {
  border-top-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode a[style] {
  color: #00D2E5 !important;
}

body.summit-theme.awsui-dark-mode sup[style] {
  color: #00D2E5 !important;
}

/* Execution time and secondary text */
body.summit-theme.awsui-dark-mode p[style*="color: #666"],
body.summit-theme.awsui-dark-mode div[style*="color: #666"] {
  color: #C4B8E0 !important;
}

/* --- CitationPanel --- */

body.summit-theme.awsui-dark-mode .citation-card,
body.summit-theme.awsui-dark-mode div[style*="backgroundColor: #ffffff"],
body.summit-theme.awsui-dark-mode div[style*="background-color: #ffffff"] {
  background-color: #1A004D !important;
  border-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode .citation-card:hover {
  background-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode .citation-card:active {
  background-color: #110033 !important;
}

body.summit-theme.awsui-dark-mode .citation-card:focus-visible {
  outline-color: #00D2E5;
}

/* Citation text */
body.summit-theme.awsui-dark-mode div[style*="color: #545b64"],
body.summit-theme.awsui-dark-mode p[style*="color: #545b64"] {
  color: #C4B8E0 !important;
}

/* Citation ref badge */
body.summit-theme.awsui-dark-mode span[style*="color: #0073bb"] {
  color: #00D2E5 !important;
}

/* --- InsightsSection --- */

/* Insight cards with white/light backgrounds */
body.summit-theme.awsui-dark-mode div[style*="background: linear-gradient(135deg, #ffffff"] {
  background: linear-gradient(135deg, #1A004D 0%, #110033 100%) !important;
  border-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode div[style*="background-color: #f0f0f0"],
body.summit-theme.awsui-dark-mode div[style*="backgroundColor: #f0f0f0"] {
  background-color: #250070 !important;
}

/* Confidence bar track */
body.summit-theme.awsui-dark-mode div[style*="background: #f0f0f0"] {
  background: #250070 !important;
}

/* General text colour fixes for dark mode content areas */
body.summit-theme.awsui-dark-mode [class*="text-content"],
body.summit-theme.awsui-dark-mode [class*="expandable-section"] p,
body.summit-theme.awsui-dark-mode [class*="chat-bubble"] p,
body.summit-theme.awsui-dark-mode [class*="chat-bubble"] li,
body.summit-theme.awsui-dark-mode [class*="chat-bubble"] h1,
body.summit-theme.awsui-dark-mode [class*="chat-bubble"] h2,
body.summit-theme.awsui-dark-mode [class*="chat-bubble"] h3,
body.summit-theme.awsui-dark-mode [class*="chat-bubble"] strong {
  color: #E8E5FF !important;
}

/* Container and card backgrounds in dark mode — let CSS tokens handle this */

/* Expandable section headers — inherit from container token */

/* Badge overrides for dark mode legibility */
body.summit-theme.awsui-dark-mode [class*="badge"][class*="green"] {
  background-color: #16a085 !important;
  color: #FFFFFF !important;
}

/* Show more link in citations */
body.summit-theme.awsui-dark-mode button[style*="color: #0972d3"] {
  color: #00D2E5 !important;
}

/* --- Light mode Summit content fixes --- */

body.summit-theme:not(.awsui-dark-mode) h1[style],
body.summit-theme:not(.awsui-dark-mode) h2[style],
body.summit-theme:not(.awsui-dark-mode) h3[style] {
  color: #110033 !important;
}

body.summit-theme:not(.awsui-dark-mode) p[style*="color: #16191f"],
body.summit-theme:not(.awsui-dark-mode) li[style*="color: #16191f"] {
  color: #1A0040 !important;
}

body.summit-theme:not(.awsui-dark-mode) strong[style] {
  color: #110033 !important;
}

body.summit-theme:not(.awsui-dark-mode) a[style*="color: #0073bb"],
body.summit-theme:not(.awsui-dark-mode) sup[style*="color: #0073bb"] {
  color: #8F0072 !important;
}

body.summit-theme:not(.awsui-dark-mode) blockquote[style] {
  border-left-color: #8F0072 !important;
  background: #F6F5FF !important;
}


/* ===================================================================
   DARK MODE — Homepage & general inline colour overrides
   =================================================================== */

/* Grey / muted text used across HomePage, InsightsSection, ReviewPage */
body.summit-theme.awsui-dark-mode div[style*="color: #5f6b7a"],
body.summit-theme.awsui-dark-mode p[style*="color: #5f6b7a"] {
  color: #C4B8E0 !important;
}

body.summit-theme.awsui-dark-mode div[style*="color: #545b64"],
body.summit-theme.awsui-dark-mode p[style*="color: #545b64"],
body.summit-theme.awsui-dark-mode span[style*="color: #545b64"] {
  color: #C4B8E0 !important;
}

body.summit-theme.awsui-dark-mode div[style*="color: #687078"],
body.summit-theme.awsui-dark-mode span[style*="color: #687078"] {
  color: #9B8FBF !important;
}

body.summit-theme.awsui-dark-mode div[style*="color: #879596"],
body.summit-theme.awsui-dark-mode span[style*="color: #879596"] {
  color: #9B8FBF !important;
}

body.summit-theme.awsui-dark-mode div[style*="color: #16191f"],
body.summit-theme.awsui-dark-mode p[style*="color: #16191f"],
body.summit-theme.awsui-dark-mode li[style*="color: #16191f"],
body.summit-theme.awsui-dark-mode span[style*="color: #16191f"] {
  color: #E8E5FF !important;
}

body.summit-theme.awsui-dark-mode div[style*="color: #495057"],
body.summit-theme.awsui-dark-mode span[style*="color: #495057"] {
  color: #C4B8E0 !important;
}

/* Homepage persona avatar placeholder background */
body.summit-theme.awsui-dark-mode div[style*="backgroundColor: #879596"],
body.summit-theme.awsui-dark-mode div[style*="background-color: #879596"] {
  background-color: #250070 !important;
}

/* Image borders */
body.summit-theme.awsui-dark-mode img[style*="border: 2px solid #eaeded"],
body.summit-theme.awsui-dark-mode img[style*="border:2px solid #eaeded"] {
  border-color: #250070 !important;
}

/* InsightsSection inline-styled headers (generated via string replace) */
body.summit-theme.awsui-dark-mode h1[style*="color: #232f3e"],
body.summit-theme.awsui-dark-mode h2[style*="color: #232f3e"],
body.summit-theme.awsui-dark-mode h3[style*="color: #232f3e"] {
  color: #E8E5FF !important;
}

/* InsightsSection code blocks */
body.summit-theme.awsui-dark-mode pre[style*="background: #f5f5f5"] {
  background: #1A004D !important;
  border-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode code[style*="background: #f0f0f0"] {
  background: #1A004D !important;
  color: #D4A8FF !important;
}

/* InsightsSection blockquotes */
body.summit-theme.awsui-dark-mode blockquote[style*="background: #f8f9fa"] {
  background: #1A004D !important;
  color: #C4B8E0 !important;
  border-left-color: #00D2E5 !important;
}

/* InsightsSection links */
body.summit-theme.awsui-dark-mode a[style*="color: #0073bb"] {
  color: #00D2E5 !important;
}

/* InsightsSection insight card white gradient backgrounds */
body.summit-theme.awsui-dark-mode [style*="linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)"] {
  background: linear-gradient(135deg, #1A004D 0%, #150029 100%) !important;
}

/* InsightsSection insight card borders */
body.summit-theme.awsui-dark-mode [style*="border: 1px solid #e0e0e0"] {
  border-color: #250070 !important;
}

/* Confidence percentage text */
body.summit-theme.awsui-dark-mode span[style*="color: #666"] {
  color: #C4B8E0 !important;
}

/* Horizontal rules in insights */
body.summit-theme.awsui-dark-mode hr[style*="border-top: 1px solid #ddd"] {
  border-top-color: #250070 !important;
}

/* ===================================================================
   DARK MODE — Cloudscape component-level overrides
   These use !important to override Cloudscape's own dark mode defaults
   when Summit theme is active.
   =================================================================== */

/* Alert component backgrounds — keep Cloudscape defaults but adjust borders */
body.summit-theme.awsui-dark-mode [class*="alert"] [class*="content"] {
  color: #E8E5FF;
}

/* Tabs — active tab indicator */
body.summit-theme.awsui-dark-mode [class*="tabs-tab"][class*="active"] {
  color: #00D2E5 !important;
}

/* Header text inside containers */
body.summit-theme.awsui-dark-mode [class*="header"] [class*="heading"] {
  color: #E8E5FF !important;
}

/* ===================================================================
   LIGHT MODE — Summit content fixes
   =================================================================== */

body.summit-theme:not(.awsui-dark-mode) h1[style],
body.summit-theme:not(.awsui-dark-mode) h2[style],
body.summit-theme:not(.awsui-dark-mode) h3[style] {
  color: #110033 !important;
}

body.summit-theme:not(.awsui-dark-mode) p[style*="color: #16191f"],
body.summit-theme:not(.awsui-dark-mode) li[style*="color: #16191f"] {
  color: #1A0040 !important;
}

body.summit-theme:not(.awsui-dark-mode) strong[style] {
  color: #110033 !important;
}

body.summit-theme:not(.awsui-dark-mode) a[style*="color: #0073bb"],
body.summit-theme:not(.awsui-dark-mode) sup[style*="color: #0073bb"] {
  color: #8F0072 !important;
}

body.summit-theme:not(.awsui-dark-mode) blockquote[style] {
  border-left-color: #8F0072 !important;
  background: #F6F5FF !important;
}

/* ===================================================================
   DARK MODE — Guardrails Showcase + AnalystReportSection + ReportPage
   Scoped to awsui-dark-mode only (no Summit theme required) because
   these components use hardcoded light-mode inline colours that break
   in any dark mode context.
   =================================================================== */

/* Question card — idle/default (white bg) */
body.awsui-dark-mode div[data-guardrail-state="idle"] {
  background: #1a2535 !important;
  border-color: #3d4f6b !important;
}

/* Question card — active/processing */
body.awsui-dark-mode div[data-guardrail-state="active"] {
  background: #0d1f35 !important;
  border-color: #0073bb !important;
}

/* Question card — passed */
body.awsui-dark-mode div[data-guardrail-state="passed"] {
  background: linear-gradient(135deg, #0d2b1a 0%, #0a1f12 100%) !important;
  border-color: #16a085 !important;
}

/* Question card — intervened */
body.awsui-dark-mode div[data-guardrail-state="intervened"] {
  background: linear-gradient(135deg, #2b0a0a 0%, #1f0808 100%) !important;
  border-color: #d62728 !important;
}

/* Guardrail intervention result box */
body.awsui-dark-mode div[data-guardrail-result="intervened"] {
  background: rgba(220, 39, 40, 0.15) !important;
  border-color: rgba(220, 39, 40, 0.5) !important;
}

/* Guardrail passed answer box — text needs to be light */
body.awsui-dark-mode div[data-guardrail-result="passed"] {
  background: rgba(22, 160, 133, 0.12) !important;
  border-color: rgba(22, 160, 133, 0.4) !important;
}

/* Text inside passed answer box */
body.awsui-dark-mode div[data-guardrail-result="passed"] p,
body.awsui-dark-mode div[data-guardrail-result="passed"] li,
body.awsui-dark-mode div[data-guardrail-result="passed"] span {
  color: #d1fae5 !important;
}

/* Result divider lines */
body.awsui-dark-mode div[style*="borderTop: 1px solid #fca5a5"] {
  border-top-color: rgba(220, 39, 40, 0.35) !important;
}
body.awsui-dark-mode div[style*="borderTop: 1px solid #86efac"] {
  border-top-color: rgba(22, 160, 133, 0.35) !important;
}

/* SWO Weaknesses card */
body.awsui-dark-mode div[style*="linear-gradient(135deg, #fef2f2 0%, #fecaca"] {
  background: linear-gradient(135deg, #2b0a0a 0%, #1f0808 100%) !important;
  border-color: #e74c3c !important;
}

/* SWO Opportunities card */
body.awsui-dark-mode div[style*="linear-gradient(135deg, #eff6ff 0%, #bfdbfe"] {
  background: linear-gradient(135deg, #0a1a2b 0%, #081220 100%) !important;
  border-color: #3498db !important;
}

/* SWO list item text (hardcoded #1a1a1a) */
body.awsui-dark-mode li[style*="color: #1a1a1a"],
body.awsui-dark-mode li[style*="color: #1A1A1A"] {
  color: #d1d5db !important;
}

/* AnalystReportSection markdown — hardcoded dark text colours */
body.awsui-dark-mode h1[style*="color: #232f3e"],
body.awsui-dark-mode h2[style*="color: #232f3e"],
body.awsui-dark-mode h3[style*="color: #232f3e"] {
  color: #e2e8f0 !important;
}

body.awsui-dark-mode p[style*="color: #16191f"],
body.awsui-dark-mode li[style*="color: #16191f"] {
  color: #cbd5e1 !important;
}

body.awsui-dark-mode strong[style*="color: #232f3e"] {
  color: #e2e8f0 !important;
}

body.awsui-dark-mode em[style*="color: #495057"] {
  color: #94a3b8 !important;
}

body.awsui-dark-mode code[style*="background: #f0f0f0"] {
  background: #1e293b !important;
  color: #93c5fd !important;
}

body.awsui-dark-mode pre[style*="background: #f5f5f5"] {
  background: #1e293b !important;
  border-color: #334155 !important;
}

body.awsui-dark-mode blockquote[style*="background: #f8f9fa"] {
  background: #1e293b !important;
  border-left-color: #3b82f6 !important;
  color: #94a3b8 !important;
}

/* Citation span highlight */
body.awsui-dark-mode span[style*="background: #f0f8ff"] {
  background: #1e3a5f !important;
  color: #60a5fa !important;
}

/* Metadata / info bars */
body.awsui-dark-mode div[style*="background: #f8f9fa"] {
  background: #1e293b !important;
  border-color: #334155 !important;
}

/* Generation progress bar track */
body.awsui-dark-mode div[style*="backgroundColor: #e9ecef"],
body.awsui-dark-mode div[style*="background-color: #e9ecef"] {
  background-color: #334155 !important;
}

/* Citation evidence cards */
body.awsui-dark-mode div[style*="background: #f8f9fa"][style*="border: 1px solid #e9ecef"] {
  background: #1e293b !important;
  border-color: #334155 !important;
}

/* Plotly chart SVG backgrounds */
body.awsui-dark-mode .js-plotly-plot .bg {
  fill: #1e293b !important;
}

/* ===================================================================
   SUMMIT DARK MODE — same fixes with Summit palette colours
   =================================================================== */

body.summit-theme.awsui-dark-mode div[data-guardrail-state="idle"] {
  background: #1A004D !important;
  border-color: #3D2066 !important;
}

body.summit-theme.awsui-dark-mode div[data-guardrail-state="passed"] {
  background: linear-gradient(135deg, #0D2B1A 0%, #0A1F12 100%) !important;
  border-color: #16a085 !important;
}

body.summit-theme.awsui-dark-mode div[data-guardrail-state="intervened"] {
  background: linear-gradient(135deg, #2B0A0A 0%, #1F0808 100%) !important;
  border-color: #d62728 !important;
}

body.summit-theme.awsui-dark-mode div[data-guardrail-result="passed"] {
  background: rgba(22, 160, 133, 0.12) !important;
  border-color: rgba(22, 160, 133, 0.4) !important;
}

body.summit-theme.awsui-dark-mode div[data-guardrail-result="passed"] p,
body.summit-theme.awsui-dark-mode div[data-guardrail-result="passed"] li,
body.summit-theme.awsui-dark-mode div[data-guardrail-result="passed"] span {
  color: #d1fae5 !important;
}

body.summit-theme.awsui-dark-mode div[style*="background: #f8f9fa"] {
  background: #150029 !important;
  border-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode div[style*="background: #f8f9fa"][style*="border: 1px solid #e9ecef"] {
  background: #1A004D !important;
  border-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode div[style*="backgroundColor: #e9ecef"],
body.summit-theme.awsui-dark-mode div[style*="background-color: #e9ecef"] {
  background-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode code[style*="background: #f0f0f0"] {
  background: #1A004D !important;
  color: #D4A8FF !important;
}

body.summit-theme.awsui-dark-mode pre[style*="background: #f5f5f5"] {
  background: #1A004D !important;
  border-color: #250070 !important;
}

body.summit-theme.awsui-dark-mode blockquote[style*="background: #f8f9fa"] {
  background: #1A004D !important;
  border-left-color: #00D2E5 !important;
}

body.summit-theme.awsui-dark-mode span[style*="background: #f0f8ff"] {
  background: #1A004D !important;
  color: #00D2E5 !important;
}

body.summit-theme.awsui-dark-mode .js-plotly-plot .bg {
  fill: #150029 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/summit-theme.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;;wEAEwE;;AAExE;EACE,wCAAwC;EACxC,8CAA8C;;EAE9C,oEAAoE;EACpE,oDAAoD;EACpD,mDAAmD;;EAEnD,wCAAwC;EACxC,uDAAuD;EACvD,qDAAqD;EACrD,sDAAsD;;EAEtD,2CAA2C;EAC3C,wDAAwD;EACxD,sDAAsD;EACtD,uDAAuD;EACvD,iEAAiE;EACjE,+DAA+D;EAC/D,gEAAgE;;EAEhE,yBAAyB;EACzB,wDAAwD;EACxD,sDAAsD;EACtD,yDAAyD;EACzD,6DAA6D;;EAE7D,sBAAsB;EACtB,gDAAgD;;EAEhD,qBAAqB;EACrB,yDAAyD;EACzD,uDAAuD;EACvD,wDAAwD;;EAExD,oBAAoB;EACpB,4DAA4D;EAC5D,sEAAsE;EACtE,uEAAuE;;EAEvE,kBAAkB;EAClB,oEAAoE;EACpE,qEAAqE;;EAErE,2BAA2B;;EAE3B,yBAAyB;EACzB,iDAAiD;;EAEjD,wBAAwB;EACxB,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,8CAA8C;;EAE9C,8BAA8B;EAC9B,mCAAmC;EACnC,gDAAgD;EAChD,8CAA8C;EAC9C,+CAA+C;EAC/C,yDAAyD;EACzD,uDAAuD;;EAEvD,cAAc;EACd,yCAAyC;EACzC,uCAAuC;EACvC,uDAAuD;EACvD,qDAAqD;EACrD,sDAAsD;;EAEtD,0BAA0B;EAC1B,mDAAmD;EACnD,iDAAiD;EACjD,kDAAkD;;EAElD,yBAAyB;EACzB,kDAAkD;EAClD,gDAAgD;EAChD,iDAAiD;;EAEjD,gBAAgB;EAChB,wCAAwC;;EAExC,6BAA6B;;EAE7B,4DAA4D;EAC5D,6CAA6C;EAC7C,iEAAiE;EACjE,+DAA+D;;EAE/D,2CAA2C;EAC3C,8CAA8C;EAC9C,8CAA8C;EAC9C,0DAA0D;EAC1D,4CAA4C;;EAE5C,oDAAoD;EACpD,kDAAkD;EAClD,mDAAmD;;EAEnD,8DAA8D;EAC9D,uDAAuD;AACzD;;AAEA,0DAA0D;AAC1D;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;wEAEwE;;AAExE;EACE,wCAAwC;EACxC,8CAA8C;;EAE9C,4EAA4E;EAC5E,oDAAoD;EACpD,mDAAmD;;EAEnD,yDAAyD;EACzD,uDAAuD;EACvD,qDAAqD;EACrD,sDAAsD;;EAEtD,0BAA0B;EAC1B,wDAAwD;EACxD,sDAAsD;EACtD,uDAAuD;EACvD,iEAAiE;EACjE,+DAA+D;EAC/D,gEAAgE;;EAEhE,yBAAyB;EACzB,wDAAwD;EACxD,sDAAsD;EACtD,yDAAyD;EACzD,6DAA6D;;EAE7D,sBAAsB;EACtB,gDAAgD;;EAEhD,sDAAsD;EACtD,yDAAyD;EACzD,uDAAuD;EACvD,wDAAwD;;EAExD,oBAAoB;EACpB,4DAA4D;EAC5D,uEAAuE;EACvE,yEAAyE;;EAEzE,kBAAkB;EAClB,mEAAmE;EACnE,qEAAqE;;EAErE,2BAA2B;;EAE3B,yBAAyB;EACzB,iDAAiD;;EAEjD,qDAAqD;EACrD,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,8CAA8C;;EAE9C,+DAA+D;EAC/D,mCAAmC;EACnC,gDAAgD;EAChD,8CAA8C;EAC9C,+CAA+C;EAC/C,yDAAyD;EACzD,uDAAuD;;EAEvD,wDAAwD;EACxD,yCAAyC;EACzC,uCAAuC;EACvC,uDAAuD;EACvD,qDAAqD;EACrD,sDAAsD;;EAEtD,6DAA6D;EAC7D,mDAAmD;EACnD,iDAAiD;EACjD,kDAAkD;;EAElD,yBAAyB;EACzB,kDAAkD;EAClD,gDAAgD;EAChD,iDAAiD;;EAEjD,gBAAgB;EAChB,wCAAwC;;EAExC,6BAA6B;;EAE7B,+DAA+D;EAC/D,6CAA6C;EAC7C,qEAAqE;EACrE,mEAAmE;;EAEnE,2CAA2C;EAC3C,8CAA8C;EAC9C,8CAA8C;EAC9C,8DAA8D;EAC9D,4CAA4C;;EAE5C,oDAAoD;EACpD,kDAAkD;EAClD,mDAAmD;;EAEnD,8DAA8D;EAC9D,uDAAuD;AACzD;;AAEA,4DAA4D;AAC5D;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;;;wEAIwE;;AAExE,8EAA8E;;AAE9E;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;;EAEE,yBAAyB;AAC3B;;AAEA,0BAA0B;;AAE1B;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;;EAEE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;;AAE5B,+CAA+C;AAC/C;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;AAChC;;AAEA,0DAA0D;AAC1D;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA,6EAA6E;;AAE7E,8DAA8D;;AAE9D,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;;AAE5C;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;;AAGA;;wEAEwE;;AAExE,wEAAwE;AACxE;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;;EAEE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;;EAEE,gCAAgC;AAClC;;AAEA,yEAAyE;AACzE;;;EAGE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,wEAAwE;AAC1E;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;AACtC;;AAEA;;;;wEAIwE;;AAExE,8EAA8E;AAC9E;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;;wEAEwE;;AAExE;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;;;;;wEAKwE;;AAExE,4CAA4C;AAC5C;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA,yDAAyD;AACzD;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA,kCAAkC;AAClC;;;EAGE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,oDAAoD;AACtD;AACA;EACE,qDAAqD;AACvD;;AAEA,wBAAwB;AACxB;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;;EAEE,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;;EAEE,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;EACE,wBAAwB;AAC1B;;AAEA;;wEAEwE;;AAExE;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/*\n * Summit 2026 Theme Overrides\n *\n * Scoped under body.summit-theme so they only apply when the Summit colour\n * theme is active.  Overrides Cloudscape Design System CSS custom properties\n * to apply the Summit 2026 branded colour palette.\n *\n * Colour palette (from 2026 Summits Standard Build Guide, page 6):\n *   Violet 50   #F6F5FF   – light body background\n *   Violet 600  #250070   – side nav / panels\n *   Violet 950  #110033   – top navigation background\n *   Violet 2735 #8F0072   – primary accent (light mode)\n *   Magenta 300 #FF9E9E   – highlight elements\n *   Purple 400  #D4A8FF   – primary accent (dark mode)\n *   Cyan 300    #00D2E5   – links / interactive\n */\n\n/* ===================================================================\n   LIGHT MODE — Summit 2026\n   =================================================================== */\n\nbody.summit-theme {\n  /* ---- Body / layout backgrounds ---- */\n  --color-background-layout-main-5ilwcb: #F6F5FF;\n\n  /* Container content & header (white/light for cards and sections) */\n  --color-background-container-content-6u8rvp: #FFFFFF;\n  --color-background-container-header-gs3mbe: #F6F5FF;\n\n  /* Side navigation / panel backgrounds */\n  --color-background-layout-panel-content-xto15e: #250070;\n  --color-background-layout-panel-hover-tguulw: #1A004D;\n  --color-background-layout-mobile-panel-ed0ava: #250070;\n\n  /* Layout toggle buttons (nav open/close) */\n  --color-background-layout-toggle-default-2hgjdu: #250070;\n  --color-background-layout-toggle-hover-0cpm7g: #1A004D;\n  --color-background-layout-toggle-active-ap91vm: #110033;\n  --color-background-layout-toggle-selected-default-izfana: #8F0072;\n  --color-background-layout-toggle-selected-hover-7953u1: #6D0058;\n  --color-background-layout-toggle-selected-active-zcl8w3: #8F0072;\n\n  /* Dropdown backgrounds */\n  --color-background-dropdown-item-default-qmc033: #F6F5FF;\n  --color-background-dropdown-item-hover-yunepc: #E8E5FF;\n  --color-background-dropdown-item-selected-f3v6te: #D4A8FF;\n  --color-background-dropdown-item-filter-match-49b5vt: #E8E5FF;\n\n  /* Input backgrounds */\n  --color-background-input-default-ifz5bb: #FFFFFF;\n\n  /* Button – primary */\n  --color-background-button-primary-default-vdt0fu: #8F0072;\n  --color-background-button-primary-hover-mo85i6: #6D0058;\n  --color-background-button-primary-active-5cqoqt: #8F0072;\n\n  /* Button – normal */\n  --color-background-button-normal-default-7f99mv: transparent;\n  --color-background-button-normal-hover-53op9s: rgba(143, 0, 114, 0.08);\n  --color-background-button-normal-active-5imwxd: rgba(143, 0, 114, 0.15);\n\n  /* Button – link */\n  --color-background-button-link-hover-lhrs2u: rgba(0, 210, 229, 0.08);\n  --color-background-button-link-active-5oi2dp: rgba(0, 210, 229, 0.15);\n\n  /* ---- Text colours ---- */\n\n  /* Top navigation title */\n  --color-text-top-navigation-title-en0v40: #FFFFFF;\n\n  /* Body & heading text */\n  --color-text-body-default-vvtq8u: #1A0040;\n  --color-text-body-secondary-bcbgoi: #3D2066;\n  --color-text-heading-default-izpp46: #110033;\n  --color-text-heading-secondary-iwtvf6: #3D2066;\n\n  /* Accent / interactive text */\n  --color-text-accent-n1kmht: #8F0072;\n  --color-text-interactive-default-ugh9wp: #00D2E5;\n  --color-text-interactive-hover-6naf7i: #00B8CC;\n  --color-text-interactive-active-uoe6zi: #009DAD;\n  --color-text-interactive-inverted-default-xlc0d5: #FFFFFF;\n  --color-text-interactive-inverted-hover-65rnp7: #F6F5FF;\n\n  /* Link text */\n  --color-text-link-default-1dmm7z: #00D2E5;\n  --color-text-link-hover-sq1gxg: #00B8CC;\n  --color-text-link-button-normal-default-5w3m67: #00D2E5;\n  --color-text-link-button-normal-hover-4awpjm: #00B8CC;\n  --color-text-link-button-normal-active-js9ryu: #009DAD;\n\n  /* Button text – primary */\n  --color-text-button-primary-default-mwl31m: #FFFFFF;\n  --color-text-button-primary-hover-pw12ep: #FFFFFF;\n  --color-text-button-primary-active-refmba: #FFFFFF;\n\n  /* Button text – normal */\n  --color-text-button-normal-default-nzalii: #8F0072;\n  --color-text-button-normal-hover-gusgyv: #6D0058;\n  --color-text-button-normal-active-vihsxh: #8F0072;\n\n  /* Status text */\n  --color-text-status-info-ue8bd2: #00D2E5;\n\n  /* ---- Border colours ---- */\n\n  --color-border-divider-default-nr68jt: rgba(37, 0, 112, 0.2);\n  --color-border-divider-active-biq3j4: #8F0072;\n  --color-border-divider-panel-bottom-bruvuz: rgba(37, 0, 112, 0.3);\n  --color-border-divider-panel-side-an0w07: rgba(37, 0, 112, 0.3);\n\n  --color-border-item-focused-uk47pl: #00D2E5;\n  --color-border-control-checked-bdv28l: #8F0072;\n  --color-border-control-default-sh3548: #250070;\n  --color-border-input-default-317xk5: rgba(37, 0, 112, 0.4);\n  --color-border-input-focused-4z0pgn: #00D2E5;\n\n  --color-border-button-normal-default-glqfp1: #8F0072;\n  --color-border-button-normal-hover-6a2tdq: #6D0058;\n  --color-border-button-normal-active-ru7yhb: #8F0072;\n\n  /* ---- Transition for smooth theme switching (Req 5.1) ---- */\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Direct element overrides for TopNavigation header bar */\nbody.summit-theme header[class*=\"top-navigation\"],\nbody.summit-theme nav[class*=\"top-navigation\"],\nbody.summit-theme [class*=\"top-navigation\"] > [class*=\"header\"] {\n  background: #110033 !important;\n  color: #FFFFFF !important;\n}\n\n/* Side navigation panel text colours (light on dark background) */\nbody.summit-theme [class*=\"side-navigation\"] {\n  color: #F6F5FF;\n}\n\nbody.summit-theme [class*=\"side-navigation\"] a,\nbody.summit-theme [class*=\"side-navigation\"] [class*=\"link\"] {\n  color: #D4A8FF;\n}\n\nbody.summit-theme [class*=\"side-navigation\"] a:hover,\nbody.summit-theme [class*=\"side-navigation\"] [class*=\"link\"]:hover {\n  color: #FFFFFF;\n}\n\nbody.summit-theme [class*=\"side-navigation\"] [class*=\"header\"] {\n  color: #FFFFFF;\n}\n\n/* ===================================================================\n   DARK MODE — Summit 2026\n   =================================================================== */\n\nbody.summit-theme.awsui-dark-mode {\n  /* ---- Body / layout backgrounds ---- */\n  --color-background-layout-main-5ilwcb: #0D001F;\n\n  /* Container content & header (slightly lighter than page bg for contrast) */\n  --color-background-container-content-6u8rvp: #150029;\n  --color-background-container-header-gs3mbe: #1A0033;\n\n  /* Side navigation / panel backgrounds (darker variant) */\n  --color-background-layout-panel-content-xto15e: #1A004D;\n  --color-background-layout-panel-hover-tguulw: #110033;\n  --color-background-layout-mobile-panel-ed0ava: #1A004D;\n\n  /* Layout toggle buttons */\n  --color-background-layout-toggle-default-2hgjdu: #1A004D;\n  --color-background-layout-toggle-hover-0cpm7g: #250070;\n  --color-background-layout-toggle-active-ap91vm: #110033;\n  --color-background-layout-toggle-selected-default-izfana: #D4A8FF;\n  --color-background-layout-toggle-selected-hover-7953u1: #C48EFF;\n  --color-background-layout-toggle-selected-active-zcl8w3: #D4A8FF;\n\n  /* Dropdown backgrounds */\n  --color-background-dropdown-item-default-qmc033: #1A004D;\n  --color-background-dropdown-item-hover-yunepc: #250070;\n  --color-background-dropdown-item-selected-f3v6te: #3D2066;\n  --color-background-dropdown-item-filter-match-49b5vt: #250070;\n\n  /* Input backgrounds */\n  --color-background-input-default-ifz5bb: #0D001F;\n\n  /* Button – primary (Purple 400 for dark legibility) */\n  --color-background-button-primary-default-vdt0fu: #D4A8FF;\n  --color-background-button-primary-hover-mo85i6: #C48EFF;\n  --color-background-button-primary-active-5cqoqt: #D4A8FF;\n\n  /* Button – normal */\n  --color-background-button-normal-default-7f99mv: transparent;\n  --color-background-button-normal-hover-53op9s: rgba(212, 168, 255, 0.1);\n  --color-background-button-normal-active-5imwxd: rgba(212, 168, 255, 0.18);\n\n  /* Button – link */\n  --color-background-button-link-hover-lhrs2u: rgba(0, 210, 229, 0.1);\n  --color-background-button-link-active-5oi2dp: rgba(0, 210, 229, 0.18);\n\n  /* ---- Text colours ---- */\n\n  /* Top navigation title */\n  --color-text-top-navigation-title-en0v40: #FFFFFF;\n\n  /* Body & heading text (light for dark backgrounds) */\n  --color-text-body-default-vvtq8u: #E8E5FF;\n  --color-text-body-secondary-bcbgoi: #C4B8E0;\n  --color-text-heading-default-izpp46: #FFFFFF;\n  --color-text-heading-secondary-iwtvf6: #D4A8FF;\n\n  /* Accent / interactive text (Purple 400 for dark legibility) */\n  --color-text-accent-n1kmht: #D4A8FF;\n  --color-text-interactive-default-ugh9wp: #00D2E5;\n  --color-text-interactive-hover-6naf7i: #33DDEC;\n  --color-text-interactive-active-uoe6zi: #00D2E5;\n  --color-text-interactive-inverted-default-xlc0d5: #110033;\n  --color-text-interactive-inverted-hover-65rnp7: #0D001F;\n\n  /* Link text (Cyan 300 — same in dark for consistency) */\n  --color-text-link-default-1dmm7z: #00D2E5;\n  --color-text-link-hover-sq1gxg: #33DDEC;\n  --color-text-link-button-normal-default-5w3m67: #00D2E5;\n  --color-text-link-button-normal-hover-4awpjm: #33DDEC;\n  --color-text-link-button-normal-active-js9ryu: #00D2E5;\n\n  /* Button text – primary (dark text on light Purple 400 bg) */\n  --color-text-button-primary-default-mwl31m: #110033;\n  --color-text-button-primary-hover-pw12ep: #110033;\n  --color-text-button-primary-active-refmba: #110033;\n\n  /* Button text – normal */\n  --color-text-button-normal-default-nzalii: #D4A8FF;\n  --color-text-button-normal-hover-gusgyv: #C48EFF;\n  --color-text-button-normal-active-vihsxh: #D4A8FF;\n\n  /* Status text */\n  --color-text-status-info-ue8bd2: #00D2E5;\n\n  /* ---- Border colours ---- */\n\n  --color-border-divider-default-nr68jt: rgba(212, 168, 255, 0.2);\n  --color-border-divider-active-biq3j4: #D4A8FF;\n  --color-border-divider-panel-bottom-bruvuz: rgba(212, 168, 255, 0.25);\n  --color-border-divider-panel-side-an0w07: rgba(212, 168, 255, 0.25);\n\n  --color-border-item-focused-uk47pl: #00D2E5;\n  --color-border-control-checked-bdv28l: #D4A8FF;\n  --color-border-control-default-sh3548: #D4A8FF;\n  --color-border-input-default-317xk5: rgba(212, 168, 255, 0.35);\n  --color-border-input-focused-4z0pgn: #00D2E5;\n\n  --color-border-button-normal-default-glqfp1: #D4A8FF;\n  --color-border-button-normal-hover-6a2tdq: #C48EFF;\n  --color-border-button-normal-active-ru7yhb: #D4A8FF;\n\n  /* ---- Transition for smooth theme switching (Req 5.1) ---- */\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Direct element overrides for TopNavigation in dark mode */\nbody.summit-theme.awsui-dark-mode header[class*=\"top-navigation\"],\nbody.summit-theme.awsui-dark-mode nav[class*=\"top-navigation\"],\nbody.summit-theme.awsui-dark-mode [class*=\"top-navigation\"] > [class*=\"header\"] {\n  background: #110033 !important;\n  color: #FFFFFF !important;\n}\n\n/* Side navigation panel text colours in dark mode */\nbody.summit-theme.awsui-dark-mode [class*=\"side-navigation\"] {\n  color: #E8E5FF;\n}\n\nbody.summit-theme.awsui-dark-mode [class*=\"side-navigation\"] a,\nbody.summit-theme.awsui-dark-mode [class*=\"side-navigation\"] [class*=\"link\"] {\n  color: #D4A8FF;\n}\n\nbody.summit-theme.awsui-dark-mode [class*=\"side-navigation\"] a:hover,\nbody.summit-theme.awsui-dark-mode [class*=\"side-navigation\"] [class*=\"link\"]:hover {\n  color: #FFFFFF;\n}\n\nbody.summit-theme.awsui-dark-mode [class*=\"side-navigation\"] [class*=\"header\"] {\n  color: #FFFFFF;\n}\n\n\n/* ===================================================================\n   DARK MODE — Content readability fixes\n   Overrides hardcoded inline colours in ReviewPage, InsightsSection,\n   and CitationPanel so text is legible on dark backgrounds.\n   =================================================================== */\n\n/* --- ReviewPage markdown renderer (inline styles use high specificity) --- */\n\nbody.summit-theme.awsui-dark-mode h1[style],\nbody.summit-theme.awsui-dark-mode h2[style],\nbody.summit-theme.awsui-dark-mode h3[style] {\n  color: #E8E5FF !important;\n}\n\nbody.summit-theme.awsui-dark-mode p[style] {\n  color: #D4CCF0 !important;\n}\n\nbody.summit-theme.awsui-dark-mode li[style] {\n  color: #D4CCF0 !important;\n}\n\nbody.summit-theme.awsui-dark-mode strong[style] {\n  color: #F6F5FF !important;\n}\n\nbody.summit-theme.awsui-dark-mode em[style] {\n  color: #C4B8E0 !important;\n}\n\nbody.summit-theme.awsui-dark-mode code[style] {\n  background: #1A004D !important;\n  color: #D4A8FF !important;\n}\n\nbody.summit-theme.awsui-dark-mode pre[style] {\n  background: #1A004D !important;\n  border-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode blockquote[style] {\n  background: #1A004D !important;\n  border-left-color: #00D2E5 !important;\n  color: #C4B8E0 !important;\n}\n\nbody.summit-theme.awsui-dark-mode hr[style] {\n  border-top-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode a[style] {\n  color: #00D2E5 !important;\n}\n\nbody.summit-theme.awsui-dark-mode sup[style] {\n  color: #00D2E5 !important;\n}\n\n/* Execution time and secondary text */\nbody.summit-theme.awsui-dark-mode p[style*=\"color: #666\"],\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #666\"] {\n  color: #C4B8E0 !important;\n}\n\n/* --- CitationPanel --- */\n\nbody.summit-theme.awsui-dark-mode .citation-card,\nbody.summit-theme.awsui-dark-mode div[style*=\"backgroundColor: #ffffff\"],\nbody.summit-theme.awsui-dark-mode div[style*=\"background-color: #ffffff\"] {\n  background-color: #1A004D !important;\n  border-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode .citation-card:hover {\n  background-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode .citation-card:active {\n  background-color: #110033 !important;\n}\n\nbody.summit-theme.awsui-dark-mode .citation-card:focus-visible {\n  outline-color: #00D2E5;\n}\n\n/* Citation text */\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #545b64\"],\nbody.summit-theme.awsui-dark-mode p[style*=\"color: #545b64\"] {\n  color: #C4B8E0 !important;\n}\n\n/* Citation ref badge */\nbody.summit-theme.awsui-dark-mode span[style*=\"color: #0073bb\"] {\n  color: #00D2E5 !important;\n}\n\n/* --- InsightsSection --- */\n\n/* Insight cards with white/light backgrounds */\nbody.summit-theme.awsui-dark-mode div[style*=\"background: linear-gradient(135deg, #ffffff\"] {\n  background: linear-gradient(135deg, #1A004D 0%, #110033 100%) !important;\n  border-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"background-color: #f0f0f0\"],\nbody.summit-theme.awsui-dark-mode div[style*=\"backgroundColor: #f0f0f0\"] {\n  background-color: #250070 !important;\n}\n\n/* Confidence bar track */\nbody.summit-theme.awsui-dark-mode div[style*=\"background: #f0f0f0\"] {\n  background: #250070 !important;\n}\n\n/* General text colour fixes for dark mode content areas */\nbody.summit-theme.awsui-dark-mode [class*=\"text-content\"],\nbody.summit-theme.awsui-dark-mode [class*=\"expandable-section\"] p,\nbody.summit-theme.awsui-dark-mode [class*=\"chat-bubble\"] p,\nbody.summit-theme.awsui-dark-mode [class*=\"chat-bubble\"] li,\nbody.summit-theme.awsui-dark-mode [class*=\"chat-bubble\"] h1,\nbody.summit-theme.awsui-dark-mode [class*=\"chat-bubble\"] h2,\nbody.summit-theme.awsui-dark-mode [class*=\"chat-bubble\"] h3,\nbody.summit-theme.awsui-dark-mode [class*=\"chat-bubble\"] strong {\n  color: #E8E5FF !important;\n}\n\n/* Container and card backgrounds in dark mode — let CSS tokens handle this */\n\n/* Expandable section headers — inherit from container token */\n\n/* Badge overrides for dark mode legibility */\nbody.summit-theme.awsui-dark-mode [class*=\"badge\"][class*=\"green\"] {\n  background-color: #16a085 !important;\n  color: #FFFFFF !important;\n}\n\n/* Show more link in citations */\nbody.summit-theme.awsui-dark-mode button[style*=\"color: #0972d3\"] {\n  color: #00D2E5 !important;\n}\n\n/* --- Light mode Summit content fixes --- */\n\nbody.summit-theme:not(.awsui-dark-mode) h1[style],\nbody.summit-theme:not(.awsui-dark-mode) h2[style],\nbody.summit-theme:not(.awsui-dark-mode) h3[style] {\n  color: #110033 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) p[style*=\"color: #16191f\"],\nbody.summit-theme:not(.awsui-dark-mode) li[style*=\"color: #16191f\"] {\n  color: #1A0040 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) strong[style] {\n  color: #110033 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) a[style*=\"color: #0073bb\"],\nbody.summit-theme:not(.awsui-dark-mode) sup[style*=\"color: #0073bb\"] {\n  color: #8F0072 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) blockquote[style] {\n  border-left-color: #8F0072 !important;\n  background: #F6F5FF !important;\n}\n\n\n/* ===================================================================\n   DARK MODE — Homepage & general inline colour overrides\n   =================================================================== */\n\n/* Grey / muted text used across HomePage, InsightsSection, ReviewPage */\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #5f6b7a\"],\nbody.summit-theme.awsui-dark-mode p[style*=\"color: #5f6b7a\"] {\n  color: #C4B8E0 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #545b64\"],\nbody.summit-theme.awsui-dark-mode p[style*=\"color: #545b64\"],\nbody.summit-theme.awsui-dark-mode span[style*=\"color: #545b64\"] {\n  color: #C4B8E0 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #687078\"],\nbody.summit-theme.awsui-dark-mode span[style*=\"color: #687078\"] {\n  color: #9B8FBF !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #879596\"],\nbody.summit-theme.awsui-dark-mode span[style*=\"color: #879596\"] {\n  color: #9B8FBF !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #16191f\"],\nbody.summit-theme.awsui-dark-mode p[style*=\"color: #16191f\"],\nbody.summit-theme.awsui-dark-mode li[style*=\"color: #16191f\"],\nbody.summit-theme.awsui-dark-mode span[style*=\"color: #16191f\"] {\n  color: #E8E5FF !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"color: #495057\"],\nbody.summit-theme.awsui-dark-mode span[style*=\"color: #495057\"] {\n  color: #C4B8E0 !important;\n}\n\n/* Homepage persona avatar placeholder background */\nbody.summit-theme.awsui-dark-mode div[style*=\"backgroundColor: #879596\"],\nbody.summit-theme.awsui-dark-mode div[style*=\"background-color: #879596\"] {\n  background-color: #250070 !important;\n}\n\n/* Image borders */\nbody.summit-theme.awsui-dark-mode img[style*=\"border: 2px solid #eaeded\"],\nbody.summit-theme.awsui-dark-mode img[style*=\"border:2px solid #eaeded\"] {\n  border-color: #250070 !important;\n}\n\n/* InsightsSection inline-styled headers (generated via string replace) */\nbody.summit-theme.awsui-dark-mode h1[style*=\"color: #232f3e\"],\nbody.summit-theme.awsui-dark-mode h2[style*=\"color: #232f3e\"],\nbody.summit-theme.awsui-dark-mode h3[style*=\"color: #232f3e\"] {\n  color: #E8E5FF !important;\n}\n\n/* InsightsSection code blocks */\nbody.summit-theme.awsui-dark-mode pre[style*=\"background: #f5f5f5\"] {\n  background: #1A004D !important;\n  border-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode code[style*=\"background: #f0f0f0\"] {\n  background: #1A004D !important;\n  color: #D4A8FF !important;\n}\n\n/* InsightsSection blockquotes */\nbody.summit-theme.awsui-dark-mode blockquote[style*=\"background: #f8f9fa\"] {\n  background: #1A004D !important;\n  color: #C4B8E0 !important;\n  border-left-color: #00D2E5 !important;\n}\n\n/* InsightsSection links */\nbody.summit-theme.awsui-dark-mode a[style*=\"color: #0073bb\"] {\n  color: #00D2E5 !important;\n}\n\n/* InsightsSection insight card white gradient backgrounds */\nbody.summit-theme.awsui-dark-mode [style*=\"linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)\"] {\n  background: linear-gradient(135deg, #1A004D 0%, #150029 100%) !important;\n}\n\n/* InsightsSection insight card borders */\nbody.summit-theme.awsui-dark-mode [style*=\"border: 1px solid #e0e0e0\"] {\n  border-color: #250070 !important;\n}\n\n/* Confidence percentage text */\nbody.summit-theme.awsui-dark-mode span[style*=\"color: #666\"] {\n  color: #C4B8E0 !important;\n}\n\n/* Horizontal rules in insights */\nbody.summit-theme.awsui-dark-mode hr[style*=\"border-top: 1px solid #ddd\"] {\n  border-top-color: #250070 !important;\n}\n\n/* ===================================================================\n   DARK MODE — Cloudscape component-level overrides\n   These use !important to override Cloudscape's own dark mode defaults\n   when Summit theme is active.\n   =================================================================== */\n\n/* Alert component backgrounds — keep Cloudscape defaults but adjust borders */\nbody.summit-theme.awsui-dark-mode [class*=\"alert\"] [class*=\"content\"] {\n  color: #E8E5FF;\n}\n\n/* Tabs — active tab indicator */\nbody.summit-theme.awsui-dark-mode [class*=\"tabs-tab\"][class*=\"active\"] {\n  color: #00D2E5 !important;\n}\n\n/* Header text inside containers */\nbody.summit-theme.awsui-dark-mode [class*=\"header\"] [class*=\"heading\"] {\n  color: #E8E5FF !important;\n}\n\n/* ===================================================================\n   LIGHT MODE — Summit content fixes\n   =================================================================== */\n\nbody.summit-theme:not(.awsui-dark-mode) h1[style],\nbody.summit-theme:not(.awsui-dark-mode) h2[style],\nbody.summit-theme:not(.awsui-dark-mode) h3[style] {\n  color: #110033 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) p[style*=\"color: #16191f\"],\nbody.summit-theme:not(.awsui-dark-mode) li[style*=\"color: #16191f\"] {\n  color: #1A0040 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) strong[style] {\n  color: #110033 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) a[style*=\"color: #0073bb\"],\nbody.summit-theme:not(.awsui-dark-mode) sup[style*=\"color: #0073bb\"] {\n  color: #8F0072 !important;\n}\n\nbody.summit-theme:not(.awsui-dark-mode) blockquote[style] {\n  border-left-color: #8F0072 !important;\n  background: #F6F5FF !important;\n}\n\n/* ===================================================================\n   DARK MODE — Guardrails Showcase + AnalystReportSection + ReportPage\n   Scoped to awsui-dark-mode only (no Summit theme required) because\n   these components use hardcoded light-mode inline colours that break\n   in any dark mode context.\n   =================================================================== */\n\n/* Question card — idle/default (white bg) */\nbody.awsui-dark-mode div[data-guardrail-state=\"idle\"] {\n  background: #1a2535 !important;\n  border-color: #3d4f6b !important;\n}\n\n/* Question card — active/processing */\nbody.awsui-dark-mode div[data-guardrail-state=\"active\"] {\n  background: #0d1f35 !important;\n  border-color: #0073bb !important;\n}\n\n/* Question card — passed */\nbody.awsui-dark-mode div[data-guardrail-state=\"passed\"] {\n  background: linear-gradient(135deg, #0d2b1a 0%, #0a1f12 100%) !important;\n  border-color: #16a085 !important;\n}\n\n/* Question card — intervened */\nbody.awsui-dark-mode div[data-guardrail-state=\"intervened\"] {\n  background: linear-gradient(135deg, #2b0a0a 0%, #1f0808 100%) !important;\n  border-color: #d62728 !important;\n}\n\n/* Guardrail intervention result box */\nbody.awsui-dark-mode div[data-guardrail-result=\"intervened\"] {\n  background: rgba(220, 39, 40, 0.15) !important;\n  border-color: rgba(220, 39, 40, 0.5) !important;\n}\n\n/* Guardrail passed answer box — text needs to be light */\nbody.awsui-dark-mode div[data-guardrail-result=\"passed\"] {\n  background: rgba(22, 160, 133, 0.12) !important;\n  border-color: rgba(22, 160, 133, 0.4) !important;\n}\n\n/* Text inside passed answer box */\nbody.awsui-dark-mode div[data-guardrail-result=\"passed\"] p,\nbody.awsui-dark-mode div[data-guardrail-result=\"passed\"] li,\nbody.awsui-dark-mode div[data-guardrail-result=\"passed\"] span {\n  color: #d1fae5 !important;\n}\n\n/* Result divider lines */\nbody.awsui-dark-mode div[style*=\"borderTop: 1px solid #fca5a5\"] {\n  border-top-color: rgba(220, 39, 40, 0.35) !important;\n}\nbody.awsui-dark-mode div[style*=\"borderTop: 1px solid #86efac\"] {\n  border-top-color: rgba(22, 160, 133, 0.35) !important;\n}\n\n/* SWO Weaknesses card */\nbody.awsui-dark-mode div[style*=\"linear-gradient(135deg, #fef2f2 0%, #fecaca\"] {\n  background: linear-gradient(135deg, #2b0a0a 0%, #1f0808 100%) !important;\n  border-color: #e74c3c !important;\n}\n\n/* SWO Opportunities card */\nbody.awsui-dark-mode div[style*=\"linear-gradient(135deg, #eff6ff 0%, #bfdbfe\"] {\n  background: linear-gradient(135deg, #0a1a2b 0%, #081220 100%) !important;\n  border-color: #3498db !important;\n}\n\n/* SWO list item text (hardcoded #1a1a1a) */\nbody.awsui-dark-mode li[style*=\"color: #1a1a1a\"],\nbody.awsui-dark-mode li[style*=\"color: #1A1A1A\"] {\n  color: #d1d5db !important;\n}\n\n/* AnalystReportSection markdown — hardcoded dark text colours */\nbody.awsui-dark-mode h1[style*=\"color: #232f3e\"],\nbody.awsui-dark-mode h2[style*=\"color: #232f3e\"],\nbody.awsui-dark-mode h3[style*=\"color: #232f3e\"] {\n  color: #e2e8f0 !important;\n}\n\nbody.awsui-dark-mode p[style*=\"color: #16191f\"],\nbody.awsui-dark-mode li[style*=\"color: #16191f\"] {\n  color: #cbd5e1 !important;\n}\n\nbody.awsui-dark-mode strong[style*=\"color: #232f3e\"] {\n  color: #e2e8f0 !important;\n}\n\nbody.awsui-dark-mode em[style*=\"color: #495057\"] {\n  color: #94a3b8 !important;\n}\n\nbody.awsui-dark-mode code[style*=\"background: #f0f0f0\"] {\n  background: #1e293b !important;\n  color: #93c5fd !important;\n}\n\nbody.awsui-dark-mode pre[style*=\"background: #f5f5f5\"] {\n  background: #1e293b !important;\n  border-color: #334155 !important;\n}\n\nbody.awsui-dark-mode blockquote[style*=\"background: #f8f9fa\"] {\n  background: #1e293b !important;\n  border-left-color: #3b82f6 !important;\n  color: #94a3b8 !important;\n}\n\n/* Citation span highlight */\nbody.awsui-dark-mode span[style*=\"background: #f0f8ff\"] {\n  background: #1e3a5f !important;\n  color: #60a5fa !important;\n}\n\n/* Metadata / info bars */\nbody.awsui-dark-mode div[style*=\"background: #f8f9fa\"] {\n  background: #1e293b !important;\n  border-color: #334155 !important;\n}\n\n/* Generation progress bar track */\nbody.awsui-dark-mode div[style*=\"backgroundColor: #e9ecef\"],\nbody.awsui-dark-mode div[style*=\"background-color: #e9ecef\"] {\n  background-color: #334155 !important;\n}\n\n/* Citation evidence cards */\nbody.awsui-dark-mode div[style*=\"background: #f8f9fa\"][style*=\"border: 1px solid #e9ecef\"] {\n  background: #1e293b !important;\n  border-color: #334155 !important;\n}\n\n/* Plotly chart SVG backgrounds */\nbody.awsui-dark-mode .js-plotly-plot .bg {\n  fill: #1e293b !important;\n}\n\n/* ===================================================================\n   SUMMIT DARK MODE — same fixes with Summit palette colours\n   =================================================================== */\n\nbody.summit-theme.awsui-dark-mode div[data-guardrail-state=\"idle\"] {\n  background: #1A004D !important;\n  border-color: #3D2066 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[data-guardrail-state=\"passed\"] {\n  background: linear-gradient(135deg, #0D2B1A 0%, #0A1F12 100%) !important;\n  border-color: #16a085 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[data-guardrail-state=\"intervened\"] {\n  background: linear-gradient(135deg, #2B0A0A 0%, #1F0808 100%) !important;\n  border-color: #d62728 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[data-guardrail-result=\"passed\"] {\n  background: rgba(22, 160, 133, 0.12) !important;\n  border-color: rgba(22, 160, 133, 0.4) !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[data-guardrail-result=\"passed\"] p,\nbody.summit-theme.awsui-dark-mode div[data-guardrail-result=\"passed\"] li,\nbody.summit-theme.awsui-dark-mode div[data-guardrail-result=\"passed\"] span {\n  color: #d1fae5 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"background: #f8f9fa\"] {\n  background: #150029 !important;\n  border-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"background: #f8f9fa\"][style*=\"border: 1px solid #e9ecef\"] {\n  background: #1A004D !important;\n  border-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode div[style*=\"backgroundColor: #e9ecef\"],\nbody.summit-theme.awsui-dark-mode div[style*=\"background-color: #e9ecef\"] {\n  background-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode code[style*=\"background: #f0f0f0\"] {\n  background: #1A004D !important;\n  color: #D4A8FF !important;\n}\n\nbody.summit-theme.awsui-dark-mode pre[style*=\"background: #f5f5f5\"] {\n  background: #1A004D !important;\n  border-color: #250070 !important;\n}\n\nbody.summit-theme.awsui-dark-mode blockquote[style*=\"background: #f8f9fa\"] {\n  background: #1A004D !important;\n  border-left-color: #00D2E5 !important;\n}\n\nbody.summit-theme.awsui-dark-mode span[style*=\"background: #f0f8ff\"] {\n  background: #1A004D !important;\n  color: #00D2E5 !important;\n}\n\nbody.summit-theme.awsui-dark-mode .js-plotly-plot .bg {\n  fill: #150029 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
